export default function isDynamicValue(obj, condition) {
  const isObject = typeof obj === "object"
  return isObject && obj?.content[0]?.content[0]?.text === condition
}
